import * as Yup from "yup";

export const reportTemplateFormValidation = Yup.object().shape({
  name: Yup.string().required("Name is required!"),
  scanTypeId: Yup.number().required("Scan type is required!"),
  content: Yup.string().required("Content is required!"),
});
